import { j as o } from "../../_virtual/jsx-runtime.js";
const l = ({
  width: r = 20,
  height: t = 20,
  viewBox: n = "0 0 20 20",
  fill: s = "currentColor",
  ...e
}) => /* @__PURE__ */ o.jsx(
  "svg",
  {
    width: r,
    height: t,
    viewBox: n,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: /* @__PURE__ */ o.jsx(
      "path",
      {
        d: "M12.557 10.4537C13.0173 10.4537 13.3904 10.8268 13.3904 11.287V16.4564C13.3904 16.9167 13.0173 17.2898 12.557 17.2898H7.55708C7.09684 17.2898 6.72375 16.9167 6.72375 16.4564L6.72375 11.287C6.72375 10.8268 7.09684 10.4537 7.55708 10.4537H12.557ZM5.25519 8.37487C5.91698 6.38857 7.7912 4.95645 9.99986 4.95645C12.2086 4.95645 14.0828 6.38857 14.7446 8.37487L13.163 8.90203C12.7219 7.57787 11.4724 6.62312 9.99986 6.62312C8.52744 6.62312 7.27795 7.57787 6.83676 8.90203L5.25519 8.37487ZM8.39041 12.1203V15.6231L11.7237 15.6231L11.7237 12.1203H8.39041Z",
        fill: s
      }
    )
  }
);
export {
  l as default
};
